/**
 * La revisión suelta de macros, en el lado del cliente.
 *
 * Documento de Jesús del 06-08-2026: se ofrece en dos momentos y de una sola forma.
 *
 *   - NUNCA como popup. "Un popup interrumpe, y esto no puede interrumpir: si aparece
 *     encima de lo que está haciendo, es publicidad aunque el texto sea suave". Va como
 *     una línea pequeña, sin botón grande, y de ahí se entra a la pantalla (/revision).
 *   - Momento 1: al recibir sus macros de inicio, el primer día. Es la revisión DE PARTIDA.
 *   - Momento 2: al recibir su ajuste del mes. Es la revisión PERSONALIZADA.
 *   - A los Niveles 2 y 3 no se les muestra nunca: ya la tienen incluida.
 *
 * EL PRODUCTO ES EL AJUSTE A MEDIDA DE 87 € (Francisco, 7-09). Hasta hoy esta venta cobraba
 * la «revisión suelta» de 147 €, que era el MISMO producto montado dos veces: misma promesa
 * (macros por entrenador y plan de suplementación), mismo cliente (el que no lleva entrenador)
 * y dos checkouts, uno a 147 y otro a 87. El de 87 es el que está en el catálogo de planes y el
 * que describe Jesús en su documento del 7-09. El de 147 se retiró; nadie lo había comprado.
 *
 * El precio de verdad lo pone el backend al cobrar (core/ajuste_a_medida.PRECIO_EUR); esto es
 * solo para escribirlo en pantalla.
 */
export const PRECIO_REVISION = 87;

/**
 * ¿Tiene uno pagado y sin entregar? Es la misma regla que el servidor (`ajuste_a_medida
 * .hay_uno_pendiente`): se puede comprar más de una vez a lo largo del tiempo, lo que no se
 * puede es tener dos a la vez.
 */
export function tieneAjustePendiente(profile) {
    const a = profile?.ajuste_a_medida;
    return !!a?.cobrado && !['entregado', 'cancelado'].includes(a?.estado);
}

/**
 * ¿Se le ofrece? Solo a quien no tiene entrenador detrás (el Nivel 1) y no tiene ya uno
 * pendiente de que se lo entreguen.
 *
 * MIRABA `revision_suelta`, el producto retirado el 7-09, así que después de pasar la venta al
 * ajuste a medida le habría seguido ofreciendo comprar a quien acababa de comprar.
 *
 * @param {object} profile  perfil del cliente
 * @param {function} can    la capacidad del plan (useAuth().can)
 */
export function seLeOfreceLaRevision(profile, can) {
    if (!profile) return false;
    if (can && can('macros_personalizados')) return false;   // Niveles 2 y 3: la llevan dentro
    return !tieneAjustePendiente(profile);
}
